import { isEmpty } from 'lodash-es';
import * as urlTemplate from 'url-template';
import { TranslocoService } from '@jsverse/transloco';
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import { DateTransformPipe } from '@app/pipes/date-format.pipe';
import { autoApi } from '@autos/auto.api';
import { ReservationVehicle } from '@app/modules/user-history/entities/history-booking-detail';
import { isNullOrUndefined } from '@app/util/util';

@Component({
  selector: 'app-auto-reservation',
  templateUrl: './auto-reservation.component.html',
  styleUrls: ['./auto-reservation.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AutoReservationComponent {

  @Input() reservation: ReservationVehicle;

  private dateFormat: string = 'E, d MMM';

  constructor(
    public translateService: TranslocoService,
    private datePipe: DatePipe,
    private dateTransformPipe: DateTransformPipe
  ) { }

  get model(): string {
    return this.reservation?.Vehicle?.Model;
  }

  get pickUp(): string {
    if (!isNullOrUndefined(this.reservation?.PickupDateTime)) {
      return this.formatDate(new Date(this.reservation?.PickupDateTime));
    }
  }

  get pickUpTime(): string {
    if (!isNullOrUndefined(this.reservation?.PickupDateTime)) {
      return this.datePipe.transform(new Date(this.reservation?.PickupDateTime), 'HH:mm');
    }
  }

  get dropOff(): string {
    if (!isNullOrUndefined(this.reservation?.DropOffDateTime)) {
      return this.formatDate(new Date(this.reservation?.DropOffDateTime));
    }
  }

  get dropOffTime(): string {
    if (!isNullOrUndefined(this.reservation?.DropOffDateTime)) {
      return this.datePipe.transform(new Date(this.reservation?.DropOffDateTime), 'HH:mm');
    }
  }

  get pickUpPlace(): string {
    const place = this.reservation?.PickupLocation.Address;
    return !isNullOrUndefined(place) && !isEmpty(place) ? place : '';
  }

  get dropOffPlace(): string {
    const place = this.reservation?.DropOffLocation.Address;
    return !isNullOrUndefined(place) && !isEmpty(place) ? place : '';
  }

  public getBackgroundImage(type: string): { backgroundImage: string } | string {
    const url = (type === 'logo')  ? this.getLogo() : this.getImage();
    if (url !== '') return { backgroundImage: `url(${encodeURI(url)})` };
    return '';
  }

  private formatDate(date: Date): string {
    return this.formatStringDate(this.datePipe.transform(date, this.dateFormat));
  }

  private formatStringDate(date: string): string {
    return this.dateTransformPipe.transform(date);
  }

  private getLogo(): string {
    const url = urlTemplate.parse(autoApi.auto_images).expand({
      provider: `${this.reservation?.Company?.Code?.toUpperCase()}`
    });
    return (this.reservation?.Company) ? url : '';
  }

  private getImage(): string {
    return (this.reservation?.Vehicle?.Image) ? this.reservation.Vehicle.Image : '';
  }
}
